import { Link, LinkProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledLink = styled<FC<LinkProps>>(Link)`
  font-weight: inherit;
  text-decoration: underline;
  white-space: normal;
  display:inline;
  outline: none;

  &:focus {
    text-decoration: inherit;
  }
  &:hover {
    text-decoration: inherit;
  }
  &:active {
    text-decoration: inherit;
  }
`;

export const StyledNoBreakWrapper = styled.span`
  display: inline;
  white-space: nowrap;
  overflow-wrap: break-word;
`;
